/* Aeternum shortlist: tap the heart on any dress to save it. Saved on this device. */
(function () {
  if (window.__aetSLReady) return;
  window.__aetSLReady = true;
  if (/^\/pages\/wishlist\/?$/.test(location.pathname)) { location.replace('/pages/shortlist' + location.search); return; }
  var KEY = 'aetShortlist';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.6-4.7-7.6-10.3A4.4 4.4 0 0 1 12 7.2a4.4 4.4 0 0 1 7.6 2.8c0 5.6-7.6 10.3-7.6 10.3z"/></svg>';

  function load() {
    try { var l = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }
  function store(l) {
    try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {}
    refresh();
  }
  function has(h) { return load().some(function (d) { return d.h === h; }); }
  function toggle(d) {
    var l = load(), i = -1;
    for (var k = 0; k < l.length; k++) if (l[k].h === d.h) i = k;
    if (i > -1) l.splice(i, 1); else l.unshift(d);
    store(l);
    return i === -1;
  }
  function remove(h) { store(load().filter(function (d) { return d.h !== h; })); }

  function handleFrom(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* Hearts on product cards (collections, search, "You may also love") */
  function addCardHearts(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(function (w) {
      if (w.querySelector('.aet-heart')) return;
      var a = w.querySelector('a[href*="/products/"]');
      var inner = w.querySelector('.card__inner');
      if (!a || !inner) return;
      var h = handleFrom(a.getAttribute('href'));
      if (!h) return;
      var img = w.querySelector('.card__media img');
      var price = w.querySelector('.price__regular .price-item, .price-item--regular, .price-item');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'aet-heart';
      b.setAttribute('data-aet-heart', '');
      b.dataset.h = h;
      b.dataset.t = (a.textContent || '').trim();
      b.dataset.i = img ? (img.currentSrc || img.src || '') : '';
      b.dataset.p = price ? price.textContent.trim() : '';
      b.innerHTML = HEART;
      inner.appendChild(b);
    });
    paint();
  }

  /* Heart in the header, in place of the account icon */
  function addHeaderLink() {
    if (document.querySelector('.aet-hl')) return;
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart || !cart.parentNode) return;
    var a = document.createElement('a');
    a.href = '/pages/shortlist';
    a.className = 'header__icon link focus-inset aet-hl';
    a.setAttribute('aria-label', 'Your shortlist');
    a.innerHTML = '<span class="aet-hl__i">' + HEART + '</span><span class="aet-hl__n" hidden></span>';
    cart.parentNode.insertBefore(a, cart);
  }

  function paint() {
    var l = load();
    document.querySelectorAll('[data-aet-heart]').forEach(function (b) {
      var on = l.some(function (d) { return d.h === b.dataset.h; });
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from your shortlist' : 'Save to your shortlist');
    });
    document.querySelectorAll('.aet-hl__n').forEach(function (n) {
      if (n.textContent !== String(l.length)) n.textContent = l.length;
      n.hidden = l.length === 0;
    });
  }

  /* The shortlist page */
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function renderPage() {
    var box = document.getElementById('AetShortlist');
    if (!box) return;
    var l = load(), base = box.dataset.base || location.origin, email = box.dataset.email || '';
    var grid = box.querySelector('.aetsl__grid'), empty = box.querySelector('.aetsl__empty'), acts = box.querySelector('.aetsl__acts');
    empty.hidden = l.length > 0;
    acts.hidden = l.length === 0;
    grid.innerHTML = l.map(function (d) {
      var url = '/products/' + encodeURIComponent(d.h);
      return '<figure class="aetsl__item"><a href="' + url + '" class="aetsl__img">' +
        (d.i ? '<img src="' + esc(d.i) + '" alt="' + esc(d.t) + '" loading="lazy">' : '') +
        '</a><figcaption><a href="' + url + '" class="aetsl__t">' + esc(d.t) + '</a>' +
        (d.p ? '<span class="aetsl__p">' + esc(d.p) + '</span>' : '') +
        '<button type="button" class="aetsl__rm" data-rm="' + esc(d.h) + '">Remove</button></figcaption></figure>';
    }).join('');
    var lines = l.map(function (d, i) { return (i + 1) + '. ' + d.t + ' - ' + base + '/products/' + d.h; }).join('\n');
    var subject = encodeURIComponent('My Aeternum shortlist');
    var toKate = encodeURIComponent('Hello Kate,\n\nHere are the dresses on my shortlist:\n\n' + lines + '\n\nI would love to talk them through with you.\n\n');
    var toMe = encodeURIComponent('My Aeternum shortlist:\n\n' + lines + '\n');
    var f = box.querySelector('[data-sl-field]');
    if (f) f.value = lines;
    var k = box.querySelector('[data-mail-kate]'), m = box.querySelector('[data-mail-me]');
    if (k) k.href = 'mailto:' + email + '?subject=' + subject + '&body=' + toKate;
    if (m) m.href = 'mailto:?subject=' + subject + '&body=' + toMe;
  }

  function refresh() { paint(); renderPage(); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-aet-heart]');
    if (!b && e.target.closest) {
      /* The card's link covers the whole card, so a tap on the heart can land on the link. Check the tap position instead. */
      var w = e.target.closest('.card-wrapper');
      var hb = w && w.querySelector('.aet-heart');
      if (hb) {
        var r = hb.getBoundingClientRect(), pad = 6;
        if (e.clientX >= r.left - pad && e.clientX <= r.right + pad && e.clientY >= r.top - pad && e.clientY <= r.bottom + pad) b = hb;
      }
    }
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      toggle({ h: b.dataset.h, t: b.dataset.t, i: b.dataset.i, p: b.dataset.p });
      return;
    }
    var r = e.target.closest && e.target.closest('[data-rm]');
    if (r) { e.preventDefault(); remove(r.getAttribute('data-rm')); }
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === KEY) refresh(); });

  function init() {
    addHeaderLink();
    addCardHearts();
    refresh();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { addHeaderLink(); addCardHearts(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.AetSL = { load: load, has: has, toggle: toggle, remove: remove };
})();
